export enum ConverterType {
  TO_JSON,
  FROM_JSON,
}

export type Payload = any;

export type Converter = {
  transform: (val: any) => any;
  checkRepetable?: (val: any) => boolean;
};

export type ConverterSet = {
  types: string[];
  [ConverterType.FROM_JSON]: Converter;
  [ConverterType.TO_JSON]: Converter;
};

export type TypeToConverterSet = Record<string, ConverterSet>;
